import request from '@/utils/request'

// 查询科技交流回复列表
export function listYwKjjlOperation(query) {
  return request({
    url: '/web/fwjg/ywKjjlOperation/list',
    method: 'get',
    params: query
  })
}

// 查询科技交流回复详细
export function getYwKjjlOperation(recid) {
  return request({
    url: '/web/fwjg/ywKjjlOperation/' + recid,
    method: 'get'
  })
}

// 新增科技交流回复
export function addYwKjjlOperation(data) {
  return request({
    url: '/web/fwjg/ywKjjlOperation',
    method: 'post',
    data: data
  })
}

// 修改科技交流回复
export function updateYwKjjlOperation(data) {
  return request({
    url: '/web/fwjg/ywKjjlOperation/edit',

    method: 'post',
    data: data
  })
}

// 删除科技交流回复
export function delYwKjjlOperation(recid) {
  return request({
    url: '/web/fwjg/ywKjjlOperation/remove/' + recid,

    method: 'post',
  })
}

// 导出科技交流回复
export function exportYwKjjlOperation(query) {
  return request({
    url: '/web/fwjg/ywKjjlOperation/export',
    method: 'get',
    params: query
  })
}